
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Space } from 'antd';
import {
  EditOutlined,
  // LockOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';
import HeaderDropdown from '../HeaderDropdown';

const AvatarDropdown = observer(({ store }: any) => {
  const navigate = useNavigate();

  const handleClick = React.useCallback((evt: any) => {
    const { key } = evt;
    if (key === 'logout') {
      store.logout().then(() => {
        navigate('/User/login');
      });
      return;
    }

    if (key === 'changePwd') {
      navigate('/User/changePassword');
      return;
    }
  }, []);

  return (
    <HeaderDropdown
      menu={{
        items: [
          {
            key: 'changePwd',
            label: (
              <>
                <EditOutlined />&nbsp;
                <FormattedMessage id="common.changePwd" defaultMessage="修改密码" />
              </>
            ),
          },
          {
            key: 'logout',
            label: (
              <>
                <LogoutOutlined />&nbsp;
                <FormattedMessage id="common.Logout" defaultMessage="登出" />
              </>
            ),
          }
        ],
        onClick: handleClick
      }}
    >
      <Space className="action">
        <Avatar style={{ color: '#FFFFFF', backgroundColor: '#A57848' }}>{ (store.config?.userInfo?.userAccount || '').charAt(0) }</Avatar>
        {store.config?.userInfo?.userAccount ?? ''}
      </Space>
    </HeaderDropdown>
  );
});

export default AvatarDropdown;
